const SignupSection = () =>{
    return(
        <div className="col-md-6">
            <div className="AppFormRight position-relative d-flex justify-content-center flex-column align-items-center text-center p-5 text-white">
                <h2 className="position-relative px-4 pb-3 mb-4">Welcome</h2>
                <p>Login to unlock the door to your account. No account yet? Sign up now! Your privacy and security are our top priority. Let's get started!</p>
                
            </div>
            
        </div>
    )
}
export default SignupSection;